<template lang="pug">
#good_service
  custom-header(
    :title="damagePrevention.area01_Title",
    :subTitle="damagePrevention.area01_SubTitle",
    :image="damagePrevention.area01_Image",
    :buttonName="damagePrevention.area01_ButtonName",
    :buttonURL="damagePrevention.area01_ButtonURL"
  )
  section.container-fluid.bg_light_blue.i_pt_12.i_pt_md_6.i_pt_sm_8.i_pb_16
    .container
      .row    
        .col-12
          .sub_title.i_mr_14.i_ml_14.i_mr_md_0.i_ml_md_0(v-html="damagePrevention.area02_Intro")
      .row
        .col-12.i_mt_6(
          v-for="(service, index) in damagePreventionList"
        )
          service-card(:item="service")
  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
    p.i_body_l.text-center(v-if="false") 也歡迎至「
      span
        router-link(
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }",
          style="cursor: pointer; color: #009ce5"
        ) 聯絡我們
      | 」留下問題，將有專人主動聯繫回覆您
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4(v-for="question in questions")
        question(:question="question")
    .row.text-center
      router-link.see_more_btn.sm.btn_yellow.text-center.i_mtb_10(
        tag="a",
        :to="{ name: 'CustomerServiceFAQ' }"
      ) 看更多
  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import ServiceCard from "@/components/customer_service/ServiceCard";
import Question from "@/components/common/Question";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import { getDamagePrevention } from "@/json/customer_service";
import { getFAQDetail } from "@/json/FAQ";

export default {
  name: "CustomerServiceDamagePrevention",
  metaInfo() {
    return {
      title: this.damagePrevention.SEO_Title,
      meta: [{ name: "description", content: this.damagePrevention.SEO_Description }],
    };
  },
  components: { ServiceCard, CustomHeader,  question: Question, "dedicated-line": DedicatedLine,},
  data() {
    return {
      cardDetail: {},
      damagePrevention: {},
      damagePreventionList: [],
      questions: [],
      FAQDetail: [],
    };
  },
  created() {
    this.getDamagePrevention();
  },
  methods: {
    getDamagePrevention() {
      getDamagePrevention().then((response) => {
        this.damagePrevention = response.data;
        this.damagePreventionList = response.data.area02_DamagePreventionList
        getFAQDetail().then((response) => {
          this.FAQDetail = response.data.FAQDeatilList;
          this.getProductQuestion();
        });
      });
    },
    getProductQuestion() {
      this.questions = [];
      if (
        this.damagePrevention.area03_FAQ01ID &&
        this.damagePrevention.area03_FAQ01ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.damagePrevention.area03_FAQ01ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.damagePrevention.area03_FAQ02ID &&
        this.damagePrevention.area03_FAQ02ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.damagePrevention.area03_FAQ02ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.damagePrevention.area03_FAQ03ID &&
        this.damagePrevention.area03_FAQ03ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.damagePrevention.area03_FAQ03ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.damagePrevention.area03_FAQ04ID &&
        this.damagePrevention.area03_FAQ04ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.damagePrevention.area03_FAQ04ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

    },
  },
};
</script>

<style scoped lang="scss">
.sub_title{
  font-size: 18px;
  font-weight: 300;
  line-height: 36px;
}
</style>
